import { ChangeDetectionStrategy, Component, input } from '@angular/core';
/**
 * Componente que define el layout de una página
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-page-layout',
  imports: [],
  template: `
  <div class="flex flex-col h-full">
    <div class="px-4 py-3 sm:px-5 md:p-2 flex-1 flex flex-col min-h-0">
      <div class="flex flex-col flex-1 min-h-0">
        @if (showTitle()) {
          <div class="flex-none flex flex-col md:flex-row justify-center items-center gap-3 mb-3 py-2 sm:gap-4 sm:mb-4 sm:py-4">
            <span class="font-bold text-primary text-xl sm:text-2xl md:text-[1.85rem] lg:text-[2.15rem] text-center md:text-left md:pl-4">{{
              pageTitle()
            }}</span>
            <ng-content select="[page-actions]"></ng-content>
          </div>
        }
        <div class="flex-1 flex flex-col min-h-0 items-center justify-center w-full">
          <ng-content select="[page-content]"></ng-content>
        </div>
      </div>
    </div>
    <div class="flex-none z-10">
       <ng-content select="[page-footer]"></ng-content>
    </div>
  </div>
  `,
  styles: ``
})
export class AppPageLayoutComponent {
  /**
   * Título de la página
   */
  pageTitle = input.required<string>();
  showTitle = input(true);
}
